import type {Language, EventRuleChange, EventRuleGroup} from '@/types'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {map, values} from 'ramda'
import {toggleSubAllWhere, toggleActive} from '@/rules-helper'
import {appSelectors} from '@/store'

import Rule from './rule'

type Props = {
  l: Language,
  group: EventRuleGroup,
  onChange: (EventRuleChange) => void,
  subGroup: EventRuleGroup,
  update: () => void,
  change: false,
}

export class RawSubGroup extends Component<Props, *> {
  state = {
    listShow: false,
  }
  showSubRules = () => {
    this.setState((prevState) => ({
      listShow: !prevState.listShow,
    }))
  }
  checkAll = (totalRules: any) => {
    let value = false
    let count = 0
    map((r) => {
      if (r.ruleCode > 528 && r.isActive === 1) {
        count++
        if (count === 7) value = true
        return value
      } else if (r.ruleCode < 529 && r.isActive === 1) {
        value = true
        return value
      } else {
        value = false
        return value
      }
    }, totalRules)
    return value
  }
  handleSubgroupNameChange = (groupName: string, totalRules: any, subGroups: any) => {
    let eventRuleChange = {}
    map((r) => {
      if (subGroups.allRuleCode === 510) {
        let count = 0
        const allRuleCode = subGroups.allRuleCode
        const anyRuleCode = subGroups.anyRuleCode
        let calculateChanges
        calculateChanges = toggleSubAllWhere(allRuleCode, anyRuleCode)
        const changes = calculateChanges(values(totalRules))
        for (let i = 0; i < changes.length; i++) {
          if (changes[i].val === 1) count++
          changes[i].check = true
          changes[i].subGroupName = groupName
          changes[i].subGroupAllRules = this.props.group.subGroupRules
          changes[i].count = count
          this.props.onChange(changes[i])
        }
      } else {
        eventRuleChange = {
          ruleCode: r.ruleCode,
          prop: 'isActive',
          val: toggleActive(r),
          check: true,
          subGroupAllRules: this.props.group.subGroupRules,
          subGroupName: groupName,
          count: toggleActive(r),
        }
        this.props.onChange(eventRuleChange)
      }
    }, totalRules)
    return eventRuleChange
  }
  render = () =>
    <div className='subRule-group' key={'index' + this.props.subGroups.name}>
      <div className="checkbox">
        <label>
          <input type= "checkbox" id='sub-group-checkbox'
            checked={this.checkAll(this.props.subGroups.subGroupRules)}
            onChange={() => this.handleSubgroupNameChange(this.props.subGroups.name, this.props.subGroups.subGroupRules, this.props.subGroups)}
          >
          </input>
          <button className ='sub-group-menu-button' onClick = {() => this.showSubRules()}>
            {this.state.listShow ? <span className='sub-group-name caret'></span> : <span className='sub-group-name caret' style={{transform: 'rotate(270deg)'}}></span>}
            <span className='sub-group-title'>{this.props.l(this.props.subGroups.name.trim())}</span>
          </button>
        </label>
      </div>
      <div className='show-sub-rules' style={{display: this.state.listShow ? 'block' : 'none'}}>
        <ul style={{listStyleType: 'none'}}>
          { map((rule) => <li key={rule.ruleCode}>
            <Rule key = {'index' + rule.ruleCode} rule={rule}
              onChange={this.props.update(this.props.subGroups.name, this.props.subGroups)} />
          </li>,
          values(this.props.subGroups.subGroupRules))
          }
        </ul>
      </div>
    </div>
}
const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
  showSubRules: false,
})

export default connect(
  mapStateToProps,
)(RawSubGroup)



// WEBPACK FOOTER //
// ./src/views/settings-page/rules/sub-rules-group.js